import { getRemainingTaskIds } from './getRemainingTaskIds';
export function getNextTaskId(storage) {
  const remainingTaskIds = getRemainingTaskIds(storage);
  if (remainingTaskIds && remainingTaskIds.length > 0) {
    return remainingTaskIds[0];
  }
  return null;
}